import { Stack } from '@mui/material';
import { compact } from 'lodash';
import { useMemo } from 'react';

import { Loader } from '@/components/progress/Loader/Loader';
import { AI_ONBOARDING_MODAL_VARIANT_CONFIGS } from '@/modules/aiOnboarding/AIOnboardingModal/AIOnboardingModal.constants';
import { AIOnboardingModalForm } from '@/modules/aiOnboarding/AIOnboardingModal/AIOnboardingModalForm/AIOnboardingModalForm';
import { dataToForm } from '@/modules/aiOnboarding/AIOnboardingModal/AIOnboardingModalForm/AIOnboardingModalForm.utils';
import { useAIOnboardingModalContext } from '@/modules/aiOnboarding/AIOnboardingModal/context/AIOnboardingModal.context';

export function AIOnboardingModalRightContent() {
  const {
    loading,
    variant,
    suggestionsByFormPath,
    household,
    principalNodesById,
    principalNodesLoading,
  } = useAIOnboardingModalContext();

  const initialValues = useMemo(() => {
    const variantFormPaths =
      AI_ONBOARDING_MODAL_VARIANT_CONFIGS[variant].formPaths;

    const variantSuggestions = compact(
      variantFormPaths.flatMap((fp) => suggestionsByFormPath[fp])
    );

    return dataToForm(variantSuggestions, household, { principalNodesById });
  }, [variant, household, suggestionsByFormPath, principalNodesById]);

  // Gate on the principal-node fetch too: initial form values depend on it, so
  // rendering before it resolves would pre-select stale/empty principals.
  if (loading || principalNodesLoading) {
    return (
      <Stack
        p={2}
        pb={4}
        width="100%"
        justifyContent="center"
        alignItems="center"
      >
        <Loader />
      </Stack>
    );
  }

  return (
    <Stack p={2} pb={4} gap={2} height="100%" sx={{ overflowY: 'scroll' }}>
      <AIOnboardingModalForm initialValues={initialValues} />
    </Stack>
  );
}
